import { Select, SelectProps } from '@cloudscape-design/components';
import { memo } from 'react';
import { convertItem, getAuditTypeOptions } from 'src/utils/generalUtils';

interface AuditTypeSelectProps {
  selectedAuditType?: string;
  options?: SelectProps.Option[];
  onSelectionChange: (auditType: string) => void;
  disabled?: boolean;
}

const AuditTypeSelect = ({
  selectedAuditType,
  onSelectionChange,
  disabled = false,
  options = getAuditTypeOptions({
    isEditCalibrationAllow: true,
    isEditProgressAllow: true,
    isEditSituationAllow: true,
    isEditTestAudit: true,
    isEditMpaAllow: true,
  }),
}: AuditTypeSelectProps) => {
  return (
    <Select
      data-testid="audit-type-select"
      selectedOption={
        selectedAuditType
          ? options.find((option) => option.value === selectedAuditType)!
          : null
      }
      placeholder="Select Audit Type"
      onChange={({ detail }) => onSelectionChange(detail.selectedOption.value!)}
      options={options}
      disabled={disabled}
    />
  );
};

export default memo(AuditTypeSelect);
